import { featuredSitters } from '../../../mocks/sitters';

interface Props {
  selectedSitterId: number | null;
  onSelect: (id: number) => void;
  onNext: () => void;
}

export default function SitterSelectStep({ selectedSitterId, onSelect, onNext }: Props) {
  return (
    <div>
      <h2 className="text-xl font-bold text-[#1B2A4A] mb-2">シッターを選ぶ</h2>
      <p className="text-sm text-[#1B2A4A]/55 mb-6">希望のシッターを選択してください</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
        {featuredSitters.map(sitter => {
          const isSelected = selectedSitterId === sitter.id;
          return (
            <button
              key={sitter.id}
              type="button"
              onClick={() => onSelect(sitter.id)}
              className={`flex items-center gap-4 p-4 rounded-2xl border-2 text-left transition-all cursor-pointer ${
                isSelected
                  ? 'border-[#81D8D0] bg-[#EEF4F7]'
                  : 'border-[#D4E8EC] bg-white hover:border-[#81D8D0]/50 hover:bg-[#F7FBFC]'
              }`}
            >
              <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0">
                <img
                  src={sitter.profileImage}
                  alt={sitter.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="text-sm font-bold text-[#1B2A4A] truncate">{sitter.name}</span>
                  {sitter.verified && (
                    <i className="ri-shield-check-fill text-[#81D8D0] text-sm flex-shrink-0"></i>
                  )}
                </div>
                <div className="flex items-center gap-1 text-xs text-[#1B2A4A]/50 mb-1">
                  <i className="ri-map-pin-line text-[#81D8D0] text-xs"></i>
                  <span className="truncate">{sitter.city}, {sitter.country}</span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-yellow-400 text-xs"></i>
                    <span className="text-xs font-semibold text-[#1B2A4A]">{sitter.rating}</span>
                    <span className="text-xs text-[#1B2A4A]/40">({sitter.reviewCount})</span>
                  </div>
                  <span className="text-sm font-bold text-[#81D8D0]">€{sitter.pricePerVisit}〜</span>
                </div>
              </div>
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-all ${
                isSelected ? 'border-[#81D8D0] bg-[#81D8D0]' : 'border-[#D4E8EC]'
              }`}>
                {isSelected && <i className="ri-check-line text-white text-xs"></i>}
              </div>
            </button>
          );
        })}
      </div>

      <button
        type="button"
        onClick={onNext}
        disabled={!selectedSitterId}
        className="w-full py-4 bg-[#81D8D0] text-white font-bold rounded-xl hover:bg-[#1B2A4A] transition-all disabled:bg-[#D4E8EC] disabled:cursor-not-allowed whitespace-nowrap"
      >
        次へ：サービスと日程を選ぶ
        <i className="ri-arrow-right-line ml-2"></i>
      </button>
    </div>
  );
}
